export const AUTH_TOKEN = "access_token"
export const CUSTOMER_LOGGED_IN = "customer_logged_in"
export const CART_ITEM = "avored-cart-items"
export const CART_TOKEN = "avored-cart-tokens"
export const AUTH_TEST = "test"
